export default __webpack_public_path__ + "static/media/ICON_Revenues.1df9a714.svg";